import styled from "styled-components";
export const SuccessModalContainer = styled.div`
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;
export const SuccessModalContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 20px;
`;
export const SuccessModalIcon = styled.div``;
export const SuccessModalIconImg = styled.img``;
export const SuccessModalTitle = styled.div`
	color: #002e5c;
	font-family: var(--SuccessModalTitleFont-family);
	font-size: 36px;
	font-weight: 600;
`;
export const SuccessModalDescription = styled.div`
	color: #002e5c;
	font-family: var(--SuccessModalDescriptionFont-family);
	font-size: 16px;
	font-weight: 400;
	line-height: 26.348px;
`;
export const SuccessModalButton = styled.div`
	display: flex;
	width: 185px;
	padding: 8px 20px;
	justify-content: center;
	align-items: center;
	border-radius: 5px;
	background: #2555ef;
	color: #ffffff;
	font-family: var(--SuccessModalButtonFont-family);
	font-size: 13px;
	font-weight: 500;
	line-height: 32px;
	text-transform: capitalize;
  cursor: pointer;
`;
